import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { VERSION } from '@ideapa/app-common';
import { LoginResponseDto } from '@ideapa/common-dto';
import { LoginStatusEnum } from '@ideapa/common-utils';
import { FormGroupState } from 'ngrx-forms';
import { AuthFacade } from '../../+state/auth.facade';
import { MAVerifyCodeFormValue } from '../../+state/auth.reducer';
import { AuthService } from '../../auth.service';

@Component({
  standalone: false,
  templateUrl: './microsoft-authenticator-setup.container.html',
  styleUrls: ['./microsoft-authenticator-setup.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MicrosoftAuthenticatorSetupContainer implements OnInit {
  loginResponse: LoginResponseDto | null = null;
  verifyMAForm$ = this.authFacade.selectVerifyMAForm$;

  constructor(
    @Inject(VERSION) public version: string,
    private authFacade: AuthFacade,
    private authService: AuthService
  ) {}

  // async proceed() {
  //   if (this.loginResponse) {
  //     this.loginResponse.loginStatus = LoginStatusEnum.needMAVerification;
  //     this.authService.setLoginResponse(this.loginResponse);
  //     this.authFacade.proceedToVerifyMA(this.loginResponse);
  //   } else {
  //     this.authFacade.missingLoginResponse();
  //   }
  // }

  ngOnInit() {
    this.loginResponse = this.authService.getLoginResponse();
  }

  async onSubmit(form: FormGroupState<MAVerifyCodeFormValue>) {
    if (form.isValid) {
      if (this.loginResponse) {
        this.loginResponse.loginStatus = LoginStatusEnum.needMAVerification;
        this.authService.setLoginResponse(this.loginResponse);
        this.authFacade.verifyMAOTP(
          form.controls.otpCode.value,
          this.loginResponse
        );
      } else {
        this.authFacade.missingLoginResponse();
      }
    }
  }
}
